import React from 'react';

const CupboardLayoutNotCheckedIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" stroke="#DF6D6D"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM4.64645 5.35355L7.29289 8L4.64645 10.6464L5.35355 11.3536L8 8.70711L10.6464 11.3536L11.3536 10.6464L8.70711 8L11.3536 5.35355L10.6464 4.64645L8 7.29289L5.35355 4.64645L4.64645 5.35355Z" fill="#DF6D6D"/>
    </svg>
);

export default CupboardLayoutNotCheckedIcon;